/**
 * api.js — typed API client
 *
 * In development:  Vite proxies /api → http://localhost:8787
 * In production:   set VITE_API_URL to your worker's URL (no trailing slash)
 *
 * Example .env:
 *   VITE_API_URL=https://pipedream-cf-worker.your-account.workers.dev
 */

const BASE = import.meta.env.VITE_API_URL ?? '';

async function request(method, path, body) {
  const opts = {
    method,
    headers: { 'Content-Type': 'application/json' },
  };
  if (body !== undefined) opts.body = JSON.stringify(body);

  const res = await fetch(`${BASE}${path}`, opts);
  const data = await res.json();

  if (!res.ok) throw new Error(data.error ?? `HTTP ${res.status}`);
  return data;
}

const get  = (path)        => request('GET',    path);
const post = (path, body)  => request('POST',   path, body);
const put  = (path, body)  => request('PUT',    path, body);
const del  = (path)        => request('DELETE', path);
const patch = (path, body) => request('PATCH',  path, body);

// ── Workflows ─────────────────────────────────────────────────────────────────
export const api = {
  workflows: {
    list:   ()             => get('/api/workflows'),
    get:    (id)           => get(`/api/workflows/${id}`),
    create: (body)         => post('/api/workflows', body),
    update: (id, body)     => put(`/api/workflows/${id}`, body),
    delete: (id)           => del(`/api/workflows/${id}`),
    toggle: (id)           => patch(`/api/workflows/${id}/toggle`),
    trigger:(id, payload)  => post(`/api/workflows/${id}/trigger`, payload ?? {}),
  },

  runs: {
    list:   (workflowId, params = {}) => {
      const qs = new URLSearchParams(params).toString();
      return get(`/api/workflows/${workflowId}/runs${qs ? '?' + qs : ''}`);
    },
    get:    (runId)   => get(`/api/runs/${runId}`),
    logs:   (runId)   => get(`/api/runs/${runId}/logs`),
  },
};

// Webhook URL helper (public endpoint — no /api prefix)
export function webhookUrl(workflowId) {
  const base = import.meta.env.VITE_API_URL ?? window.location.origin;
  return `${base}/webhook/${workflowId}`;
}
